// extracted by mini-css-extract-plugin
export default {"group-item-tree":"wrH3l"};